<template>
    <div class="container d-flex">
        <div class="row flex-1 align-items-center">
            <div class="col text-center text-muted mx-4">
                <div class="col text-right">
                    <b-button variant="primary" @click="acionarJob">                                      
                        Acionar Api-Cidadão
                    </b-button>
                </div>
                <h6>Página atualizada de 10 em 10 segundos assim que acionar o botão...</h6>
                <div class="m-2">
                    <b-table small
                            bordered
                            striped
                            responsive 
                            :fields="tabela.fields" 
                            :items="tabela.listaMsg">
                            <template v-slot:cell(data_inicio)="data">
                                {{$helpers.formatTimeZoneToDateTimeBr(data.value)}}
                            </template>
                            <template v-slot:cell(data_alteracao)="data">
                                {{$helpers.formatTimeZoneToDateTimeBr(data.value)}}
                            </template>
                            <template v-slot:cell(data_fim)="data">
                                {{$helpers.formatDateHourToDateTimeBr(data.value)}}
                            </template>
                    </b-table> 
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
      return {
        log: null,
        processo:null,
        timerId:null,
        qtdRegistros:null,
        tabela: {
            listaMsg: [],
            fields: [
                {
                    key: 'msg',
                    label: 'Log',
                    class: 'text-left'                                                                                                      
                },
                {
                    key: 'data_inicio',
                    label: 'Data/Hora Início',
                    class: 'text-left'                                                                                                      
                },
                {
                    key: 'data_alteracao',
                    label: 'Data/Hora Alteração',
                    class: 'text-left'                                                                                                      
                }, 
                {
                    key: 'data_fim',
                    label: 'Data/Hora Fim',
                    class: 'text-left'                                                                                                      
                },                           
            ],
        }, 
      }
  },
  methods: {


    acionarJob(){
        this.tabela.listaMsg = [];
        this.qtdRegistros = null;
        this.$api.get(`buscar-cidadao`)
            .then(response => {  
                if(response.status == 200){
                    this.processo = response.data;
                        this.$nextTick(() => {
                            this.tabela.listaMsg.push({msg:'->Início do Processamento', data_inicio:response.data.created_at}); 
                            this.atualizaJob();
                        });

                }                                                            
            })
            .catch(error => {   
                if(error.response.data){                        
                    this.$helpers.showToast(this,'Erro', error.response.data.message, 'danger');                        
                }                                                                          
            }); 
    },

    atualizaJob()
    {
        var params = this.processo.id;
        this.$api.get(`${params}/job-status`)
        .then(response =>
        {
            if(this.processo.id  == response.data.id)
            {
                this.processo = response.data;
            
                if(this.qtdRegistros === null){
                    this.tabela.listaMsg.push({msg:'->Quantidade de registros a serem lidos: '+response.data.progress_max}); 
                    this.qtdRegistros = response.data.progress_max;
                } 
                
                var othis = this;
                if(response.data && (response.data.status=="executing" || response.data.status=="queued") )
                {
                    this.tabela.listaMsg.push({msg:"- Quantidade de registros já lidos: "+response.data.progress_now,
                                            data_alteracao:response.data.updated_at
                    }); 
                    this.$nextTick(() => {
                        this.timerId  = setTimeout(function(){ othis.atualizaJob() }, 10000);
                    });
                } else{
                    this.tabela.listaMsg.push({msg:"->Quantidade total de registros lidos: "+response.data.progress_now});
                    this.tabela.listaMsg.push({msg:"->Processamento finalizado.",
                                                data_fim:response.data.finished_at});
                }
            }

        })
    },
  },
};
</script>

